// Add event listeners for all popup buttons
var popupBtns = document.querySelectorAll('.popup-btn');
popupBtns.forEach(function(btn) {
  btn.addEventListener('click', function(e) {
    e.stopPropagation();
    var popupId = btn.getAttribute('data-popup-id');
    var popup = document.querySelector('.popup[data-popup-id="' + popupId + '"]');
    var overlay = document.querySelector('.popup-overlay[data-overlay-id="' + popupId + '"]');
    popup.style.display = 'block';
    overlay.style.display = 'block';
  });
});

// Add event listeners for all popup close buttons
var closeBtns = document.querySelectorAll('.popup-close');
closeBtns.forEach(function(btn) {
  btn.addEventListener('click', function() {
    var popupId = btn.parentNode.getAttribute('data-popup-id');
    var popup = document.querySelector('.popup[data-popup-id="' + popupId + '"]');
    var overlay = document.querySelector('.popup-overlay[data-overlay-id="' + popupId + '"]');
    popup.style.display = 'none';
    overlay.style.display = 'none';
  });
});

// Add event listener to close all popups when clicking outside of the popup
document.querySelector('body').addEventListener('click', function() {
  var popups = document.querySelectorAll('.popup');
  var overlays = document.querySelectorAll('.popup-overlay');
  popups.forEach(function(popup) {
    popup.style.display = 'none';
  });
  overlays.forEach(function(overlay) {
    overlay.style.display = 'none';
  });
});

// Prevent clicks within the popup from closing the popup
var popups = document.querySelectorAll('.popup');
popups.forEach(function(popup) {
  popup.addEventListener('click', function(e) {
    e.stopPropagation();
  });
});